import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

export default async function updatePublication(body) {
    try {
        return await axios.put(`${REACT_APP_API}/publications/meli/pubs`, body)
    } catch (error) {
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        throw error
    }
}
